import { render, staticRenderFns } from "./CargandoWeighTruck.vue?vue&type=template&id=1d996bfb&scoped=true"
import script from "./CargandoWeighTruck.vue?vue&type=script&lang=ts"
export * from "./CargandoWeighTruck.vue?vue&type=script&lang=ts"
import style0 from "./CargandoWeighTruck.vue?vue&type=style&index=0&id=1d996bfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d996bfb",
  null
  
)

export default component.exports